{
  "confirmClosePosition": {
    "title": "Position will be closed when the market opens",
    "description_1": "When using the \"Close Position\" function, a Market order to sell (if the position was opened Long) or buy (if the position was opened Short) is automatically placed.",
    "description_2": "Please note that the Market order will be executed immediately after the market opens, but the price may differ from the current value due to possible high volatility.",
    "description_3": "We recommend paying attention to current market conditions and making decisions taking into account possible price fluctuations.",
    "cancelButton": "Cancel",
    "confirmButton": "Close Position"
  }
}
